import React from 'react';
import { Link } from 'react-router-dom';
import helpConfig from '../../content/help/config.json';
import { HelpConfig } from '../../types/Help';

const config = helpConfig as HelpConfig;

export default function HelpHome() {

  document.title = `Wilma Help`;

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Help Center</h1>
      <p className="text-gray-600 mb-8">
        Browse our documentation to learn how to use the platform effectively.
      </p>

      <div className="grid gap-6 md:grid-cols-2">
        {config.categories.map((category) => (
          <Link
            key={category.id}
            to={`/help/${category.id}`}
            className="block p-6 border border-gray-200 rounded-lg hover:border-wilma-600 hover:shadow-lg transition-shadow"
          >
            <h2 className="text-2xl font-semibold mb-2 text-wilma-600">{category.title}</h2>
            {category.description && (
              <p className="text-gray-600 mb-4">{category.description}</p>
            )}
            <div className="text-sm text-gray-500">
              {category.pages.length} {category.pages.length === 1 ? 'article' : 'articles'}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

